// Searching the People list in a library's access settings.
import type { LocalUser } from '../api/types'

/** People whose `user@host` or display name contains the query (case-insensitive). */
export function filterPeople(users: readonly LocalUser[], query: string): LocalUser[] {
  const q = query.trim().toLowerCase()
  if (!q) return [...users]
  return users.filter((u) => u.user_id.toLowerCase().includes(q) || u.display_name.toLowerCase().includes(q))
}
